import styled from "styled-components";

interface FrameProps {
  $backgroundColor?: string;
}

export const Page = styled.main`
  min-height: 100vh;
  background: #f1f5f9;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
`;

export const DesktopFrame = styled.div<FrameProps>`
  width: 100%;
  max-width: 1200px;
  min-height: 100vh;
  background: ${({ $backgroundColor }) => $backgroundColor || "#ffffff"};
  border: 1px solid #e5e7eb;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 0;
  box-sizing: border-box;
`;

export const MobileFrame = styled.div<FrameProps>`
  width: 375px;
  max-width: 100%;
  min-height: 100vh;
  background: ${({ $backgroundColor }) => $backgroundColor || "#ffffff"};
  border: 1px solid #e5e7eb;
  border-radius: 0;
  margin: 0 auto;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
`;

export const ScrollContainer = styled.div`
  height: 100vh;
  overflow-y: auto;
`;

export const StateCard = styled.div`
  width: 100%;
  max-width: 800px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 24px;

  h2 {
    margin: 0;
    color: #0f172a;
    font-size: 22px;
    font-weight: 700;
  }

  p {
    margin: 10px 0 0;
    color: #475569;
    font-size: 15px;
    line-height: 1.6;
  }
`;
